<template>
    <div>
        <h4 class="border-bottom pb-05 mb-1">{{ __('group.title_pending_join_requests') }}</h4>

        <input class="form-control round" type="text" name="search_term" id="search_term" v-model="search_term" v-on:input="debounceInput" placeholder="Type to search...">

        <div style="max-height: 655px; overflow-y: auto;">
            <ul class="list-group m-1 p-0" v-for="(member, index) in members" :key="index">
                <pending-followers :module="module" :member="member" @removed="removeFromView(index)"
                                   :section="section"
                                   :admin=admins>
                </pending-followers>
            </ul>
        </div>
        <infinite-loading ref="infiniteLoadingJoins" :identifier="infiniteId" @distance="1" @infinite="infiniteHandler">
            <div slot="no-more"></div>
            <div slot="no-results"> {{ __('group.form.validation.no_pending_join_requests') }}</div>
        </infinite-loading>
    </div>
</template>

<script>

export default {
    name: "PendingGroupJoins",
    props: ['module', 'section', 'admins'],
    data() {
        return {
            members: [],
            page: 1,
            user: window.App.user,
            infiniteId: +new Date(),
            search_term: '',
            admin_list: this.admins
        }
    },
    methods: {
        infiniteHandler($state) {
            let vm = this;
            axios
                .get(this.getUrl())
                .then(response => {
                    let entries = Object.values(response.data.data)
                    if (entries.length > 0) {
                        $.each(entries, function (key, value) {
                            vm.members.push(value);
                        });
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                });
            vm.page++;
        },
        removeFromView(index) {
            this.members.splice(index, 1);
        },
        getUrl() {
            return '/member/'+this.section+'/pending-members?id='+this.module.id+'&page='+this.page+'&search_term='+this.search_term;
        },
        debounceInput: _.debounce(function (e) {
            this.search_term = e.target.value;
            this.page = 1;
            this.members = [];
            this.infiniteId += 1;
        }, 500)
    },
    mounted() {
        // Used to manually trigger infinite loading
        this.$refs.infiniteLoadingJoins.$emit('infinite', this.$refs.infiniteLoadingJoins.stateChanger);
    }
}
</script>

<style scoped>

    ::-webkit-scrollbar {
      width: 10px;
    }

    ::-webkit-scrollbar-thumb {
      background: #c7c5c5;
      border-radius: 5px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: grey;
    }

</style>
